import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ordersApi } from '../services/api';

function StatCard({ value, label, color, to, sub }) {
  const card = (
    <div className="stat-card" style={{ borderTop: `3px solid ${color}` }}>
      <div className="stat-value" style={{ color }}>{value ?? '—'}</div>
      <div className="stat-label">{label}</div>
      {sub && <div className="stat-trend" style={{ color }}>{sub}</div>}
    </div>
  );
  return to ? <Link to={to} style={{ textDecoration: 'none' }}>{card}</Link> : card;
}

function fmt(n) {
  return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(n || 0);
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [recentOrders, setRecentOrders] = useState([]);

  useEffect(() => {
    ordersApi.stats().then(setStats);
    ordersApi.list({ limit: 10 }).then(r => setRecentOrders(r.data));
  }, []);

  const STATUS_LABELS = {
    waiting_payment: 'Čeká na platbu',
    paid: 'Zaplaceno',
    packed: 'Zabaleno',
    shipped: 'Odesláno',
    pickup_ready: 'Vyzvednutí',
    cancelled: 'Zrušeno',
  };
  const STATUS_CLASS = {
    waiting_payment: 'badge-waiting',
    paid: 'badge-paid',
    packed: 'badge-packed',
    shipped: 'badge-shipped',
    pickup_ready: 'badge-pickup',
    cancelled: 'badge-cancelled',
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Přehled</h1>
        <Link to="/orders/new" className="btn btn-primary">+ Nová objednávka</Link>
      </div>

      {/* Stats grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12, marginBottom: 24 }}>
        <StatCard value={stats?.waiting} label="Čeká na platbu" color="var(--orange)" to="/orders?status=waiting_payment" />
        <StatCard value={stats?.paid} label="Zaplaceno" color="var(--green)" to="/orders?status=paid" />
        <StatCard value={stats?.packed} label="Zabaleno" color="var(--blue)" to="/orders?status=packed" />
        <StatCard value={stats?.shipped} label="Odesláno" color="var(--teal)" to="/orders?status=shipped" />
        <StatCard value={fmt(stats?.revenue_today)} label="Tržby dnes" color="var(--blue)" />
        <StatCard value={fmt(stats?.revenue_month)} label="Tržby tento měsíc" color="var(--green)" />
        {stats?.overdue > 0 && (
          <StatCard value={stats.overdue} label="Po splatnosti" color="var(--red)" to="/orders?status=waiting_payment" sub="⚠ Upomínky" />
        )}
      </div>

      {/* Quick actions */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12, marginBottom: 24 }}>
        {[
          { to: '/packing', icon: '📫', label: 'Balírna', desc: `${stats?.paid || 0} k zabalení`, color: 'var(--green)' },
          { to: '/shipping', icon: '🚚', label: 'Expedice', desc: `${stats?.packed || 0} ke zpracování`, color: 'var(--teal)' },
          { to: '/facebook', icon: '📣', label: 'Publikovat na FB', desc: 'Nový příspěvek', color: 'var(--blue)' },
          { to: '/payments', icon: '💳', label: 'Párovanie plateb', desc: 'Synchronizovat banku', color: 'var(--orange)' },
        ].map(a => (
          <Link key={a.to} to={a.to} style={{ textDecoration: 'none' }}>
            <div className="card" style={{ cursor: 'pointer', borderLeft: `4px solid ${a.color}`, padding: '14px 16px' }}>
              <div style={{ fontSize: 24, marginBottom: 6 }}>{a.icon}</div>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{a.label}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{a.desc}</div>
            </div>
          </Link>
        ))}
      </div>

      {/* Recent orders */}
      <div className="card">
        <div className="card-header">
          <div className="card-title">Poslední objednávky</div>
          <Link to="/orders" className="btn btn-secondary btn-sm">Zobrazit vše</Link>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Číslo</th>
                <th>Zákazník</th>
                <th>Status</th>
                <th>Doručení</th>
                <th>Celkem</th>
                <th>Datum</th>
              </tr>
            </thead>
            <tbody>
              {recentOrders.map(o => (
                <tr key={o.id}>
                  <td><Link to={`/orders/${o.id}`} style={{ fontWeight: 600, color: 'var(--blue)' }}>{o.order_number}</Link></td>
                  <td>{o.customer_name}</td>
                  <td><span className={`badge ${STATUS_CLASS[o.status] || ''}`}>{STATUS_LABELS[o.status] || o.status}</span></td>
                  <td>{o.delivery_method === 'post' ? '📮 Pošta' : o.delivery_method === 'pickup' ? '🏠 Vyzvednutí' : '🤝 Osobně'}</td>
                  <td style={{ fontWeight: 600 }}>{fmt(o.total_amount)}</td>
                  <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>{o.created_at?.slice(0, 10)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {recentOrders.length === 0 && <div className="empty-state">Zatím žádné objednávky</div>}
        </div>
      </div>
    </div>
  );
}
